import { styled } from "@mui/material";

import twToCss from "utils/twToCssHelper";

export const Btn = styled("button")`
	${twToCss("relative rounded-[20px] w-full bg-[#FF4032] p-[3px]")};

	box-shadow: 0 1px 0 0 #ff7575 inset;

	&:before {
		content: "";

		${twToCss("absolute top-1 left-0 w-full h-full z-[-1] rounded-[20px]")};

		background: linear-gradient(180deg, #450905 92.79%, #af0707 100%);
	}

	.input {
		${twToCss("w-full h-full border-none bg-transparent text-lg text-yellow-350 font-mic py-0.5 px-2.5")};

		&::placeholder {
			${twToCss("text-yellow-350 opacity-80")};
		}
	}

	.btn-content {
		${twToCss("w-full h-fit border-none rounded-[17px] p-[3px]")};
		background: linear-gradient(180deg, #450905 0%, #af0707 100%);
	}

	.btn-selector {
		${twToCss("rounded-[20px] flex-1 h-7 flex items-center justify-center gap-1")};

		border: 1px solid transparent;
	}

	&.filled {
		.btn-selector {
			background: linear-gradient(180deg, #ff574b 0%, #bb1509 71.5%, #ff3e30 100%);
			box-shadow: 0px -1px 0px 0px #ff6358 inset;
		}
	}

	&.gold-border {
		${twToCss("bg-yellow-400")};

		box-shadow: 0 1px 0 0 #fff1b5 inset;
	}

	&:hover {
		box-shadow:
			0px 0px 12px 0px rgba(255, 62, 62, 0.8),
			0px -1px 0px 0px rgba(212, 62, 39, 0.6) inset;
	}

	&.size {
		&_XS {
			.btn-selector {
				${twToCss("h-3")};
			}
		}

		&_SM {
			.btn-selector {
				${twToCss("h-4")};
			}
		}
	}
`;
